var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLink = function SvgIconLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 21 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#171923",
    d: "M12.477 1.453a5 5 0 0 1 7.07 7.07l-.012.012-4 4a5 5 0 0 1-7.07 0 1 1 0 1 1 1.414-1.414 3 3 0 0 0 4.242 0l3.993-3.994a3 3 0 0 0-4.241-4.241l-1.094 1.093a1 1 0 1 1-1.414-1.414l1.1-1.1zM6.465 7.465a5 5 0 0 1 7.07 0 1 1 0 1 1-1.414 1.414 3 3 0 0 0-4.242 0l-4 4-.012.012a3 3 0 1 0 4.242 4.242l.012-.012 1.102-1.101a1 1 0 1 1 1.414 1.414L9.54 18.53a5 5 0 1 1-7.07-7.07z"
  })));
};
export default SvgIconLink;